<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.fhsaRecurring.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.fhsaRecurring.NOW_YOU_CAN"></p>
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.fhsaRecurring.DESCRIPTION_I"></p>
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.fhsaRecurring.DESCRIPTION_II"></p>
      <a class="td-wb-modal-notification__link"
         href="#/modal/transfers/cash"
         translate="tdWb.modalNotification.fhsaRecurring.START_TRANSFER"></a>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <img tdWbModalNotificationImage
           src="fhsa-recurring.svg"
           width="180px"
           [attr.alt]="'tdWb.modalNotification.fhsaRecurring.TITLE' | translate"
           class="td-wb-modal-notification--image-small">
    </div>
  </div>
</div>
